module.exports = __webpack_public_path__ + "static/media/fact_5.eb258c4b.png";